import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { Link } from 'react-router-dom';

const Inicio = () => {
  const [buttonColor, setButtonColor] = useState('originalColor');

  useEffect(() => {
    AOS.init({ duration: 800 });

    const handleScroll = () => {
      const footer = document.getElementById('footer');
      const footerPosition = footer.getBoundingClientRect().top;
      const screenPosition = window.innerHeight;

      if (footerPosition <= screenPosition) {
        setButtonColor('nuevoColor');
      } else {
        setButtonColor('originalColor');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="container mt-4">
      <h1 className="text-center font-weight-bold mb-2 mb-md-4">Ferretería El Constructor</h1>    
      
      <div className="row mt-2 align-items-center"> 
        <div className="col-md-6 text-justify" data-aos="fade-right">
          <p className="text-muted text-justify mb-1">
            Somos una empresa enfocada en ofrecer productos para la construcción, mismos que deben cumplir parámetros esenciales como: calidad, precios competitivos, disponibilidad inmediata, gran gama y variedad. Para este propósito se han desarrollado alianzas y metodologías con nuestros proveedores, manejándose mediante canales directos con las principales fábricas y/o distribuidores, esto con la finalidad de lograr los mejores beneficios en suministros de mercadería, así como los mejores precios del mercado.
          </p>
        </div>
        <div className="col-md-6 text-center" data-aos="fade-left">
          <img
            src="./images/home.jpg"
            alt="Imagen de inicio"
            className="img-fluid img-mision"
            data-toggle="modal"
            data-target="#modalHome"
          />
        </div>
      </div>

      <h3 className="text-left mt-5 font-weight-bold ml-2" data-aos="fade-up">Misión</h3>
      <div className="row mt-3 align-items-center"> 
        <div className="col-md-6" data-aos="fade-right">
          <p className="text-muted text-justify">
            Proveer al por mayor y menor, artículos de calidad acorde a las expectativas de nuestros clientes, contribuyendo así al crecimiento socio-económico del país.
          </p>
          <h3 className="text-left mt-4 font-weight-bold ml-2" data-aos="fade-down">Visión</h3> 
          <p className="text-muted text-justify">
            Mantener el crecimiento sostenido de la empresa, mediante la incorporación de nuevos productos y servicios, e incursionar en otros mercados a través de estrategias que nos lleven a posicionarnos entre los principales comercializadores del sector ferretero.
          </p>
        </div>
        <div className="col-md-6 text-center" data-aos="fade-left">
          <img
            src="./images/vision.jpg"
            className="img-fluid img-mapa-territorial"
            alt="imagen de mision"
            data-toggle="modal"
            data-target="#modalMision"
          />
        </div>
      </div>

      <h3 className="text-center mt-5 font-weight-bold" data-aos="fade-up">Contáctenos</h3>
      <h4 className="text-center mt-5 titulo-aviso" data-aos="fade-up">
        ¡Cuidado no caiga en engaños y estafas de números desconocidos!
      </h4>
      <div className="text-center" data-aos="zoom-out" data-aos-easing="linear" data-aos-duration="2500">
        <img src="./images/aviso.gif" className="img-fluid img-aviso" alt="imagen de celular" />
      </div>
      <h4 className="text-justify mt-5 font-weight-bold" data-aos="fade-up">
        Estafadores están utilizando nuestro nombre y marca para intentar estafar a nuestros clientes. Les recomendamos que únicamente se comunique con los números que aparecen en esta página. Manténgase alerta y proteja su información personal.
      </h4>

      <div style={{ display: 'flex', justifyContent: 'center' }} data-aos="flip-up"> 
        <Link to="/contacto" className="btn btn-ir-contactos">
          Click aquí para ir a la sección de contactos
        </Link>
      </div>

      <div className="frase">
        ¡La rapidez nuestro compromiso, la variedad nuestra ventaja y la calidad nuestro respaldo!
      </div>

      <Link to="/reclutamiento" className={`btn-aplicar-fijo ${buttonColor}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-person-badge mr-2" viewBox="0 0 16 16">
          <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"/>
          <path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
          <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492z"/>
        </svg>
        Reclutamiento de personal
      </Link>

      <footer id="footer">
      </footer>

    </div>
  );
};

export default Inicio;
